<div class="street-panel">
    <mat-form-field 
        appearance="standard" FloatLabelType="never"
        class="ft-address-unit-num">
        <input matInput #eUnitNo
            [id]="'unitNo'+keyName" placeholder="Unit#"
            (blur)="propertyValueChange($event, 'unitNo')"
            [name]="keyName+'unitNumD'" [readonly]="isReadOnly"
            [formControl]="formControlUnitNo"/>
    </mat-form-field>


    <mat-form-field 
        appearance="standard"
        class="ft-address-street-num">
        <input  matInput #eStreetNo
            [id]="'streetNo'+keyName" placeholder="Street#"
            (blur)="propertyValueChange($event, 'streetNo')"
            [name]="keyName+'streetD'" [readonly]="isReadOnly"
            [formControl]="formControlStreetNo"
             />

    </mat-form-field>

    <mat-form-field
        appearance="standard"
        class="ft-address-street-name">
        <input matInput #eStreetName
            [id]="'streetName'+keyName"
            placeholder="Street Name"
            (blur)="propertyValueChange($event, 'street')"
            [name]="keyName+'streetNameD'" [readonly]="isReadOnly"
            [formControl]="formControlStreetName" />
    </mat-form-field>


</div>




<div class="suburb-state-panel f-flex f-flex-row f-flex-wrap">

    <mat-form-field
        appearance="standard"
        class="ft-address-suburb">
        <input matInput #eSuburbTown
            [id]="'suburbTown'+keyName"
               placeholder="Suburb / Town"
               (blur)="propertyValueChange($event, 'suburb')"
               [name]="keyName+'subUrbTownD'" [readonly]="isReadOnly"
               [formControl]="formControlSuburb" />
    </mat-form-field >

    <mat-form-field 
        appearance="standard"
        class="ft-address-state">
        <input matInput #eState
            [name]="keyName+'stateD'"
               [id]="'state'+keyName" placeholder="State"
               (blur)="propertyValueChange($event, 'state')"
                [readonly]="isReadOnly"
                [formControl]="formControlState" />
    </mat-form-field >


</div>


<div class="country-postcode-panel f-flex f-flex-row f-flex-wrap">

    <mat-form-field 
        appearance="standard"
        class="ft-address-post-code-country">
        <input matInput #eCountry
             [id]="'country'+keyName"
               placeholder="Country"
               (blur)="propertyValueChange($event, 'country')"
               [name]="keyName+'countryD'" [readonly]="isReadOnly"
               [formControl]="formControlCountry" />
    </mat-form-field >

    <mat-form-field
        appearance="standard"
        class="ft-address-post-code">
        <input matInput #ePostCode
            [id]="'postCode'+keyName"
               placeholder="Postcode"
               (blur)="propertyValueChange($event, 'postcode')"
               [name]="keyName+'postcodeD'" [readonly]="isReadOnly"
               [formControl]="formControlPostcode" />
    </mat-form-field >



</div>




<div class="description-lat-lon-panel f-flex f-flex-row f-flex-wrap">

    <mat-form-field 
        appearance="standard"
        class="ft-address-description">
        <textarea matInput #eLocationDescription
            [id]="'locationDescription'+keyName"
                  placeholder="Location Description"
                  (blur)="propertyValueChange($event, 'locationDescription')"
                  [name]="keyName+'descriptionAddressD'" [readonly]="isReadOnly"
                  [formControl]="formControlLocationDescription"
                  ></textarea>
    </mat-form-field >

    <div class="lat-lon-panel f-flex f-flex-column">
        <mat-form-field
            appearance="standard"
            class="ft-address-long-lat ">
            <input matInput #eLatitude
                [id]="'latitudeId'+keyName"
                   placeholder="Latitude" (blur)="coordinateValueChange($event, 1)"
                   [name]="keyName+'latitudeD'" [readonly]="isReadOnly" />
        </mat-form-field>

        <mat-form-field
            appearance="standard"
            class="ft-address-long-lat">
            <input matInput #eLongitude
                [id]="'longtitudeId'+keyName"
                   placeholder="Longitude" (blur)="coordinateValueChange($event, 0)"
                   [name]="keyName+'longitudeD'" [readonly]="isReadOnly" />
        </mat-form-field>


    </div>


</div>